/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The configuration of the animatic for a screw compressor.
 */
export type AnimaticScrewCompressorConfig = {
  /**
   * Whether to flip the orientation of the screw compressor.
   */
  flip?: boolean | undefined;
  /**
   * Whether the screw compressor is undergoing service.
   */
  isServiceRequired?: boolean | undefined;
  /**
   * Whether the screw compressor is undergoing trim.
   */
  isTrim?: boolean | undefined;
};

/** @internal */
export const AnimaticScrewCompressorConfig$inboundSchema: z.ZodType<
  AnimaticScrewCompressorConfig,
  z.ZodTypeDef,
  unknown
> = z.object({
  flip: types.boolean().default(false),
  is_service_required: types.boolean().default(false),
  is_trim: types.boolean().default(false),
}).transform((v) => {
  return remap$(v, {
    "is_service_required": "isServiceRequired",
    "is_trim": "isTrim",
  });
});
/** @internal */
export type AnimaticScrewCompressorConfig$Outbound = {
  flip: boolean;
  is_service_required: boolean;
  is_trim: boolean;
};

/** @internal */
export const AnimaticScrewCompressorConfig$outboundSchema: z.ZodType<
  AnimaticScrewCompressorConfig$Outbound,
  z.ZodTypeDef,
  AnimaticScrewCompressorConfig
> = z.object({
  flip: z.boolean().default(false),
  isServiceRequired: z.boolean().default(false),
  isTrim: z.boolean().default(false),
}).transform((v) => {
  return remap$(v, {
    isServiceRequired: "is_service_required",
    isTrim: "is_trim",
  });
});

export function animaticScrewCompressorConfigToJSON(
  animaticScrewCompressorConfig: AnimaticScrewCompressorConfig,
): string {
  return JSON.stringify(
    AnimaticScrewCompressorConfig$outboundSchema.parse(
      animaticScrewCompressorConfig,
    ),
  );
}
export function animaticScrewCompressorConfigFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticScrewCompressorConfig, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticScrewCompressorConfig$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticScrewCompressorConfig' from JSON`,
  );
}
